import { TinyColor } from '@ctrl/tinycolor';
import { get, find } from 'lodash';
const throwRequired = (name) => {
    throw new Error(`${name} is required`);
};
export const getStyleColor = (appSettings, wixParam) => get(appSettings, `style.colors[${wixParam}].value`);
export const getPresetColor = (appSettings, presetName) => get(find(appSettings.colorPresets, ({ reference }) => reference === presetName), 'value');
export const setColorOpacity = (color, alpha = 1) => new TinyColor(color).setAlpha(alpha).toRgbString();
export const getSiteColor = (appSettings, { wixParam, presetFallback, colorFallback, opacity = undefined }) => {
    if (!wixParam) {
        throwRequired('wixParam');
    }
    if (!presetFallback) {
        throwRequired('presetFallback');
    }
    if (!colorFallback) {
        throwRequired('colorFallback');
    }
    const color = getStyleColor(appSettings, wixParam) ||
        getPresetColor(appSettings, presetFallback) ||
        colorFallback;
    return opacity !== undefined
        ? setColorOpacity(color, opacity)
        : new TinyColor(color).toRgbString();
};
export const resolveColor = (color, colorPresets) => {
    if (!color) {
        return 'transparent';
    }
    if (!color.includes('{')) {
        return color;
    }
    const currentColor = color.replace(/[\{\}]/g, '');
    const siteColor = find(colorPresets, ({ name }) => name === currentColor);
    return get(siteColor, 'value', 'transparent');
};
//# sourceMappingURL=colors.js.map